import styled, { css } from 'styled-components'
import { DefaultTheme } from 'styled-components'
import { ColorSchemeTypes } from '../../../types/ColorScheme'
import { Heading } from '../../atoms/Typography/Typography.styles'
import gridConfig from '../../../theme/grid-config'

interface StickyCtaWrapperProps {
  theme: DefaultTheme
  isExpanded: boolean
  colorScheme: ColorSchemeTypes
}

interface StickyCtaContentProps {
  theme: DefaultTheme
  isExpanded: boolean
  colorScheme: ColorSchemeTypes
}

export const StickyCtaWrapper = styled.div<StickyCtaWrapperProps>`
  position: fixed;
  bottom: ${({ theme }) => theme.rem(24)};
  right: ${({ theme }) => theme.rem(24)};
  z-index: ${({ theme }) => theme.layers.stickyCta};
  max-width: ${({ theme }) => theme.rem(375)};
  width: ${({ theme }) => theme.rem(375)};

  ${({ theme }) => theme.mediaQuery.md(`
    bottom: ${theme.rem(32)};
    right: ${theme.rem(32)};
  `)}
`

export const StickyCtaContent = styled.div<StickyCtaContentProps>`
  background-color: ${({ theme }) => theme.palette.grayscale['50']};
  border-radius: ${({ isExpanded, theme }) => isExpanded ? 0 : theme.rem(8)};
  padding: ${({ theme }) => theme.rem(16)};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  ${({ theme }) => theme.mediaQuery.md(`
    padding: ${theme.rem(24)};
  `)}
`

export const StickyCtaInnerContainer = styled.div<{ isExpanded: boolean }>`
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  ${({ theme }) => Object.entries(theme.breakpoints).map(([dim]) => theme.mediaQuery[dim](`
    max-width: ${gridConfig({ theme }).container[dim]};
    padding-left: ${theme.rem(gridConfig({ theme }).paddingWidth[dim])};
    padding-right: ${theme.rem(gridConfig({ theme }).paddingWidth[dim])};
  `))}

  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: ${({ theme }) => theme.rem(16)};

  ${({ theme, isExpanded }) => theme.mediaQuery.md(`
    gap: ${theme.rem(20)};
    flex-direction: ${isExpanded ? 'row' : 'column'};
    align-items: ${isExpanded ? 'center' : 'stretch'};
    justify-content: ${isExpanded ? 'space-between' : 'flex-start'};
  `)}

  ${Heading} {
    color: ${({ theme }) => theme.palette.grayscale['900']};
  }
`

export const StickyCtaTitle = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`

export const StickyCtaButton = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
`

